import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
import { PRICE } from '../../data/checkout';
import { GUARANTEE_LINE } from '../../data/woodworking';
import { PREMIUM_SEALS } from '../../data/premium';
export function FinalCta() {
  return <section aria-labelledby="final-title" className="bg-charcoal py-16 sm:py-24" data-id="element-263" data-mp="1snjar3elhvxh">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center px-5 text-center sm:px-8" data-id="element-264" data-mp="1eobae76p4hrp">
        <span className="block h-px w-12 bg-brass-light" aria-hidden data-id="element-265" data-mp="1ipwq00am7a5l" />
        <h2 id="final-title" className="mt-8 text-balance font-brand text-[1.8rem] font-bold leading-[1.18] tracking-[-0.01em] text-ivory min-[390px]:text-[1.95rem] sm:text-[2.45rem] lg:text-[2.75rem]" data-id="element-266" data-mp="1insf2yeatavt">
          A full table this Christmas—built by you.
        </h2>
        <p className="mt-4 text-[1.02rem] leading-relaxed text-parchment sm:text-[1.1rem]" data-id="element-267" data-mp="2z56d35erynkp">
          30 projects that sell, six volumes, cut lists in inches and millimeters and five bonus resources—yours for life.
        </p>
        <CheckoutButton id="final-cta" label={`GET THE 30 PROJECTS — ${PRICE.label}`} size="lg" className="mt-8 w-full sm:w-auto" data-id="element-268" data-mp="27acop9ymjn1" />
        <p className="mt-4 inline-flex items-center gap-2 text-[0.95rem] font-semibold text-ivory" data-id="element-269" data-mp="b16u5qs6j7w4">
          <ShieldCheckIcon className="h-5 w-5 text-brass-light" aria-hidden data-id="element-270" data-mp="703fh7lvbhwh" />
          {GUARANTEE_LINE}
        </p>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-3 gap-y-1 text-[0.8rem] font-semibold uppercase tracking-[0.1em] text-brass-light" data-id="element-271" data-mp="3ff51keyc91ou">
          {PREMIUM_SEALS.map((seal, index) => <li key={seal} className="inline-flex items-center gap-3" data-id="element-272" data-mp="3ogus7ikebwlk" data-mpi={index}>
              {index > 0 && <span className="h-1 w-1 rounded-full bg-brass-light/60" aria-hidden data-id="element-273" data-mp="3jhi30r61ydft" />}
              {seal}
            </li>)}
        </ul>
      </div>
    </section>;
}